import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, OnDestroy }
  from '@angular/core';
import { PricingDiscountResult } from '../../models/pricing-discount-result.model';
import { DwMessage, DwMessageSeverity, DwEventService } from '@devwareapps/devware-cap';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-discount-code',
  templateUrl: './discount-code.component.html',
  styleUrls: ['./discount-code.component.scss']

})
export class DiscountCodeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() discountCode: string;
  @Input() showLink: boolean = true;
  @Output() discountCodeChange = new EventEmitter<string>();

  @Output() discountCodeApplied = new EventEmitter<string>();
  @Output() discountCodeCleared = new EventEmitter<void>();
  @Output() discountCodeError = new EventEmitter<void>();
  @Output() viewChanged = new EventEmitter<string>();

  @Input() discountResult: PricingDiscountResult;

  view: DiscountView = DiscountView.link;
  @Input() mode: DiscountMode = DiscountMode.normal;

  @Input() hideErrors: boolean = false;

  errorMessage: DwMessage;

  constructor(protected dwEventService: DwEventService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.discountResult) {
      this.setupDiscountView();
    }
  }

  setView(view: DiscountView) {
    this.view = view;
    this.viewChanged.emit(view);
  }

  setupDiscountView() {
    this.errorMessage = null;

    if (!this.discountResult)
      return this.setView(DiscountView.link);
    else if (this.discountResult.IsValid)
      return this.setView(DiscountView.success);

    this.setView(DiscountView.enterCode);

    this.errorMessage = {
      messageBody: this.discountResult.Message,
      severity: DwMessageSeverity.error
    }
  }
  CHANGE_VIEW = 'DISCOUNT-VIEW-CHANGE';
  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.subscriptions.push(
      this.dwEventService.getEventData<any>(this.CHANGE_VIEW)
        .subscribe(data => {
          this.setView(data?.view);
          this.discountCode = data?.code;
        })
    );
  }
  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  haveCodeLinkClick() {
    this.setView(DiscountView.enterCode);
  }

  applyDiscountCode() {
    this.errorMessage = null;

    if (this.discountCode) {
      this.discountCodeApplied.emit(this.discountCode);
    } else {
      this.errorMessage = {
        messageBody: 'Please enter a discount code.',
        severity: DwMessageSeverity.error
      }
    }
  }

  clearDiscountCode() {
    this.discountCode = '';
    this.discountResult = null;

    this.setView(DiscountView.link);

    this.discountCodeCleared.emit();
  }
}

export enum DiscountView {
  link = 'link',
  enterCode = 'enterCode',
  success = 'success',
  error = 'error'
}
export enum DiscountMode {
  normal = 'normal',
  flat = 'flat',
}
